module.exports = __webpack_public_path__ + "static/images/graph.ef140705a51a843226b717714add0611.svg";